import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  selected: {
    background: '#F5F5F5 !important',
    color: `#6F7072`,
  },
  fullWidth: {
    width: '100%',
  },
  buttonStyle: {
    minWidth: '56px',
    height: '100%',
  },
});
